import { linkify } from "./linkify";
const HttpUrlPattern = new RegExp(
  "^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$",
  "i"
);
const isValidExactUrl = (str) => HttpUrlPattern.test(str);
const isValidTelUrl = (str) => /^tel:[0-9-()+#*]+$/.test(str);
const containsUrl = (url) => url && url[0] !== "#" && linkify.test(url);
const isValidUrl = (url, options = {}) => !!url && (containsUrl(url) || !!(options.allowTelLink && isValidTelUrl(url)));
const isMaliciousUrl = (url) => url.toLowerCase().trim().startsWith("data:");
const normalizeHref = (value) => {
  if (isValidTelUrl(value)) {
    return value;
  }
  const [urlValue, anchor] = value.split("#");
  const normalizedUrl = urlValue && linkify.match(urlValue) && linkify.match(urlValue)?.[0]?.url;
  if (normalizedUrl === null) {
    return void 0;
  }
  return anchor ? `${normalizedUrl}#${anchor}` : normalizedUrl;
};
const getUrlMatches = (text) => linkify.match(text) || [];
const normalizeUrl = (url) => {
  const result = url && linkify.match(url) && linkify.match(url)?.[0];
  if (result && ["http:", "https:", ""].includes(result.schema)) {
    return result.url;
  }
  return null;
};
const startsWithHttps = (url) => /^https:/.test(url);
const startsWithHttp = (url) => /^http:/.test(url);
const getHost = (url) => !url ? url : !startsWithHttps(url) && !startsWithHttp(url) ? new URL(`http://${url}`).host : new URL(url).host;
export {
  containsUrl,
  getHost,
  getUrlMatches,
  isMaliciousUrl,
  isValidExactUrl,
  isValidTelUrl,
  isValidUrl,
  normalizeHref,
  normalizeUrl
};
//# sourceMappingURL=urlValidators.js.map
